/** Leading locale segment for i18n routes (e.g. /en/topics → /en). */
export function localePathPrefix(pathname) {
  const segments = pathname.split('/').filter(Boolean);
  const first = segments[0];
  if (first && /^[a-z]{2}(?:-[A-Z]{2})?$/.test(first)) {
    return `/${first}`;
  }
  return '';
}
